
export const onMobileChangeExecute = function (callback) {
    var currentView = isMobileView();
    $(window).on('orientationchange resize', function () {
        if (isMobileView() != currentView) {
            currentView = isMobileView();
            callback(currentView);
        }
    });
};
